// API-домен для запросов авторизации (в dev — пустой префикс, путь идёт через CRA-прокси)
const apiDomain = process.env.REACT_APP_API_DOMAIN

const apiBase = window.location.origin === 'http://localhost:3000'
    ? ''
    : 'https://' + apiDomain

// Эндпоинты API авторизации → api.xsocks.pro
export const authUrl = apiBase + '/login'
export const signupUrl = apiBase + '/signup'

// SPA-маршрут страницы логина (редирект на хосте фронта) — всегда относительный
export const loginUrl = '/login'
